import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AppNav from "@/components/AppNav";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import PracticePlayer from "@/pages/PracticePlayer";
import Book from "@/pages/Book";
import Corporate from "@/pages/Corporate";
import Progress from "@/pages/Progress";
import Videos from "@/pages/Videos";
import MyPlan from "@/pages/MyPlan";
import ChangePassword from "@/pages/ChangePassword";
import Admin from "@/pages/Admin";
import AdminClientPlan from "@/pages/AdminClientPlan";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppNav />
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/book" element={<Book />} />
              <Route path="/corporate" element={<Corporate />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<ArticleDetail />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
              <Route path="/practice/:id" element={<ProtectedRoute><PracticePlayer /></ProtectedRoute>} />
              <Route path="/progress" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
              <Route path="/videos" element={<ProtectedRoute><Videos /></ProtectedRoute>} />
              <Route path="/my-plan" element={<ProtectedRoute><MyPlan /></ProtectedRoute>} />
              <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              <Route path="/admin/client/:userId/plan" element={<ProtectedRoute adminOnly><AdminClientPlan /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
